import { render, staticRenderFns } from "./claimInfo.vue?vue&type=template&id=128f179e&scoped=true"
import script from "./claimInfo.vue?vue&type=script&lang=js"
export * from "./claimInfo.vue?vue&type=script&lang=js"
import style0 from "./claimInfo.vue?vue&type=style&index=0&id=128f179e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128f179e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('128f179e')) {
      api.createRecord('128f179e', component.options)
    } else {
      api.reload('128f179e', component.options)
    }
    module.hot.accept("./claimInfo.vue?vue&type=template&id=128f179e&scoped=true", function () {
      api.rerender('128f179e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/claim/recordManage/claimInfo.vue"
export default component.exports